import React from 'react';

export default function (props) {
    return (
        <div style={{ ...props.style }}>
            <svg
                width={props.size}
                height={props.size}
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill={props.color}
                    style={{ background: '#FFF' }}
                    d="M10,4.9c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1C15.1,7.2,12.8,4.9,10,4.9L10,4.9
		z M10,13.3c-1.8,0-3.3-1.5-3.3-3.3S8.2,6.7,10,6.7s3.3,1.5,3.3,3.3C13.3,11.8,11.8,13.3,10,13.3z"/>
                <path
                    fill={props.color}
                    style={{ background: '#FFF' }}
                    d="M14.1,0.1C12.3,0,7.7,0,5.9,0.1c-1.6,0.1-3,0.5-4.2,1.6C-0.2,3.6,0,6.2,0,10c0,3.9-0.2,6.4,1.7,8.3
		C3.6,20.2,6.3,20,10,20c3.8,0,5.2,0,6.5-0.5c1.8-0.7,3.2-2.4,3.4-5.3c0.1-1.8,0.1-6.4,0-8.2C19.7,2.4,17.9,0.3,14.1,0.1L14.1,0.1z
		 M17,17c-1.3,1.3-3,1.1-7,1.1c-4.2,0-5.8,0.1-7-1.2c-1.4-1.4-1.1-3.6-1.1-7c0-4.6-0.5-7.9,4.1-8.1c1.1,0,1.4,0,4,0l0,0
		c4.4,0,7.9-0.5,8.1,4.1c0,1.1,0.1,1.4,0.1,4C18.2,14.1,18.2,15.8,17,17L17,17z"/>
                <circle className="st0" cx="15.3" cy="4.7" r="1.2"
                    fill={props.color}
                    style={{ background: '#FFF' }} />
            </svg>
        </div>
    );
}
